class OneRestService {
  constructor(axios, security, path) {
    this.axios = axios;
    this.securityToken = '';
    this.securityParams = '';
    this.path = '';
    if (path !== null && path !== undefined) {
      this.path = path;
    }
    if (security && security.token && security.token.length) {
      this.securityToken = security.token;
    } else if (security && security.username && security.password) {
      this.securityParams = '?user=' + security.username + '&password=' + security.password + '&locale=' + security.locale;
    }    
  }

  handleError(error) {
    if (error.response) {
      // Request made and server responded
      if (error.response.status === 401) {
        throw "Unauthorized";
      } else {
        console.log(error.response.status, error.response.data, error.response.headers);
        if ('detail' in error.response.data) {
          throw error.response.data.detail;
        } else {
          throw JSON.stringify(error.response.data);
        }
      }
    } else if (error.request) {
      throw "The request was made but no response was received " + JSON.stringify(error.request);
    } else {
      throw "Something happened in setting up the request that triggered an Error" + JSON.stringify(error);
    }
  }

  handleAuth(config) {
    config.path = this.path + config.path;
    if (this.securityToken) {
      config.postConfig.headers['X-API-Key'] = this.securityToken;
    }
    if (this.securityParams) {
      config.path += this.securityParams;
    }
  }

  injectCsrfToken(config) {
    if (config.postConfig.headers) {
      config.postConfig.headers['X-CSRF-Token'] = this.getCookie("one.erp.rest.csrf.token");
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }  

  async get(entityName, key) {
    let config = {
      path: '/rest/entity/' + entityName + '/' + key,
      postConfig: {
        headers: {}
      }
    }
    this.handleAuth(config);
    try {
      let response = await this.axios.get(config.path, config.postConfig);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      this.handleError(error);
    }
  }

  async put(entityName, entity) {
    let config = {
      path: '/rest/entity/' + entityName,
      postConfig: {
        headers: {}
      }
    }
    this.handleAuth(config);
    try {
      let response = await this.axios.post(config.path, entity, config.postConfig);
      if (response.status === 200) {
        return response.data.key;
      }
    } catch (error) {
      this.handleError(error);
    }
    return null;
  }

  async update(entityName, entity) {
    let config = {
      path: '/rest/entity/' + entityName + '/' + entity.properties.key,
      postConfig: {
        headers: {}
      }
    }
    this.handleAuth(config);
    try {
      let response = await this.axios.post(config.path, entity, config.postConfig);
      if (response.status === 200) {
        return response.data.key;
      }
    } catch (error) {
      this.handleError(error);
    }
    return false;
  }

  async delete(entityName, entityKey) {
    let config = {
      path: '/rest/entity/' + entityName + '/' + entityKey,
      postConfig: {
        headers: {}
      }
    }
    this.handleAuth(config);
    try {
      let response = await this.axios.delete(config.path, config.postConfig);
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      this.handleError(error);
    }
    return false;
  }

  async fetch(query) {
    let config = {
      path: '/rest/fetch',
      postConfig: {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8'
        }
      }
    }
    this.handleAuth(config);
    try {
      let response = await this.axios.post(config.path, query, config.postConfig);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      this.handleError(error);
    }
    return null;
  }

  async workflow(wfName, wfMethod, wfRequest) {
    let config = {
      path: '/rest/workflow/' + wfName + '/' + wfMethod,
      postConfig: {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }
    }
    this.handleAuth(config);
    this.injectCsrfToken(config);
    try {
      const response = await this.axios.post(config.path, wfRequest || {}, config.postConfig);

      return response;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  async rest(restPath) {
    let config = {
      path: '/rest' + restPath,
      postConfig: {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8'
        }
      }
    }

    try {
      let response = await this.axios.post(config.path, null, config.postConfig);

      return response;
    } catch (error) {
      this.handleError(error);
    }
    return null;
  }
}

export default function (axios, securityToken) {
  let security = securityToken ? { token: securityToken } : null;

  return new OneRestService(axios, security);
}
